import { roundNumber } from './maths';

// Function to calculate the cumulative sum of an array of numbers
export const cumulativeSum = (array: number[]) =>
  array.map(
    (
      (sum) => (value) =>
        (sum = roundNumber(sum + value))
    )(0)
  );
